import axios from "axios";

export default axios.create({
    baseURL: `${location.origin}/${process.env.VUE_APP_BASE_PATH ? `${process.env.VUE_APP_BASE_PATH}/` : ''}api`,
    headers: {
        "Content-type": "application/json"
    }
});